import React, { useEffect, useState } from "react";
import Select from "react-select";
import { parsePhoneNumberFromString, getCountryCallingCode, AsYouType } from "libphonenumber-js";
import { COUNTRIES } from "../../constants";

const CountryCodeDropDownAdmin = ({ label, phoneNumber, onPhoneNumberChange }) => {
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [inputPhoneNumber, setInputPhoneNumber] = useState("");

    // Convert COUNTRIES array to Select options
    const options = COUNTRIES.map((country) => ({
        label: (
            <div style={{ display: "flex", alignItems: "center", fontSize: "10px" }}>
                <img
                    src={`https://flagcdn.com/w40/${country.region.toLowerCase()}.png`}
                    alt={country.name}
                    style={{ width: 24, height: 16, marginRight: 10 }}
                />
                {country.name} ({getCountryCallingCode(country.region)})
            </div>
        ),
        value: country.region,
    }));

    useEffect(() => {
        if (phoneNumber) {
            const parsedNumber = parsePhoneNumberFromString(`+${phoneNumber}`);
            if (parsedNumber) {
                const countryCode = parsedNumber.country;
                const matchedCountry = COUNTRIES.find((country) => country.region === countryCode);
                if (matchedCountry) {
                    const defaultOption = {
                        label: (
                            <div style={{ display: "flex", alignItems: "center", fontSize: "10px" }}>
                                <img
                                    src={`https://flagcdn.com/w40/${matchedCountry.region.toLowerCase()}.png`}
                                    alt={matchedCountry.name}
                                    style={{ width: 24, height: 16, marginRight: 10 }}
                                />
                                {matchedCountry.name} (+{getCountryCallingCode(matchedCountry.region)})
                            </div>
                        ),
                        value: matchedCountry.region,
                    };
                    setSelectedCountry(defaultOption);
                    const formattedPhone = formatPhoneNumber(parsedNumber.nationalNumber);
                    setInputPhoneNumber(formattedPhone);
                }
            }
        }
    }, [phoneNumber]);

    // Handle country selection change
    const handleCountryChange = (selectedOption) => {
        const countryCode = getCountryCallingCode(selectedOption.value);
        setSelectedCountry(selectedOption);
        setInputPhoneNumber(""); // Reset phone input on country change
        onPhoneNumberChange(`${countryCode}`); // Prefill with country code
    };

    // Format phone number input with spaces based on country
    const formatPhoneNumber = (number) => {
        if (selectedCountry) {
            const asYouType = new AsYouType(selectedCountry.value);
            let formattedNumber = asYouType.input(number);

            // Remove unwanted characters (like brackets, hyphens, etc.)
            formattedNumber = formattedNumber.replace(/[^\d\s]/g, '');

            return formattedNumber;
        }
        return number;
    };


    // Handle phone number input
    const handlePhoneNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // Remove all non-digit characters
        setInputPhoneNumber(value);
        if (selectedCountry) {
            const fullNumber = `${value}`; // Only include national number
            const formatted = formatPhoneNumber(fullNumber); // Format input
            setInputPhoneNumber(formatted); // Update input with formatted number
            onPhoneNumberChange(`${getCountryCallingCode(selectedCountry.value)}${formatted}`);
        }
    };

    return (
        <>


            <div className="d-flex align-items-center" style={{ paddingTop: "18px" }}>
            <label htmlFor="Phone">{label}</label>
                <Select
                    options={options}
                    value={selectedCountry}
                    onChange={handleCountryChange}
                    styles={{
                        control: (provided, state) => ({
                            ...provided,
                            width: 200,
                            marginLeft:'-2px',
                            border: "none",
                            boxShadow: state.isFocused ? "none" : provided.boxShadow,
                            outline: "none",
                        }),
                        dropdownIndicator: (provided) => ({
                            ...provided,
                            cursor: "pointer",
                        }),
                    }}
                    className="country-select pt-2" // You can add this class for styling
                />
            </div>
            <div className="position-relative w-100 d-flex">
                {/* <label htmlFor="Phone">{label}</label> */}
                <input
                    type="text"
                    placeholder="Enter phone number"
                    value={formatPhoneNumber(inputPhoneNumber)}
                    onChange={handlePhoneNumberChange}
                    className="phone-input" // You can add this class for styling
                />
            </div>
        </>
    );
};

export default CountryCodeDropDownAdmin;
